import angular from 'angular';
import angularSanitize from 'angular-sanitize';
import angularTranslate from 'angular-translate';
import ngCookies from 'angular-cookies';
import uiSelect from 'ui-select';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { IccDrawComponent } from '@icc/draw';
import { DrawService } from './services/draw.service';

import config from './configs/config';
import appConfig from './configs/appConfig';

import appTemplate from './app.html';
import AppCtrl from './app.controller';
import serieSelectorDirective from './components/serieSelector';
import clickableIconDirective from './components/clickableIcon';
import simpleSelectBoxDirective from './components/simpleSelectBox';
import handleSelectorDirective from './components/handleSelector';
import configuratorHeaderDirective from './components/configuratorHeader';
import componentSelectorDirective from './components/componentSelector';
import modalAccessoriesDirective from './components/modalAccessories';
import colorSelectorDirective from './components/colorSelector';
import glassSelectorDirective from './components/glassSelector';
import glazingSelectorDirective from './components/glazingSelector';
import barsSelectorDirective from './components/barsSelector';
import packetSelectorDirective from './components/packetSelector';
import toggleSimpleSelectBoxDirective from './components/toggleSimpleSelectBox';
import simpleBlindSelectorDirective from './components/simpleBlindSelector';
import rollerBlindBoxSelectorDirective from './components/rollerBlindBoxSelector';
import rollerBlindFabricSelectorDirective from './components/rollerBlindFabricSelector';
import internalBlindTopRailSelectorDirective from './components/internalBlindTopRailSelector';
import internalBlindLouvreSelectorDirective from './components/internalBlindLouvreSelector';
import plisseRailSelectorDirective from './components/plisseRailSelector';
import plisseSheatingSelectorDirective from './components/plisseSheatingSelector';
import verticalBlindTopRailSelectorDirective from './components/verticalBlindTopRailSelector';
import verticalBlindLouvreSelectorDirective from './components/verticalBlindLouvreSelector';
import modalDirective from './components/modal';

import additionalMoneyFilter from './filters/additionalMoney.filter';

import dataService from './services/data.service';
import apiService from './services/api.service';
import imagesService from './services/images.service';
import jsonService from './services/json.service';
import jsonBuilderService from './services/jsonBuilder.service';
import sashesService from './services/sashes.service';
import dividersService from './services/dividers.service';
import addMullionService from './services/addMullion.service';
import windowDimensionsService from './services/windowDimensions.service';
import internalSashesService from './services/internalSashes.service';
import mullionsService from './services/mullions.service';
import fixedSashesService from './services/fixedSashes.service';
import handlesService from './services/handles.service';
import callbacksService from './services/callbacks.service';
import ncsService from './services/ncs.service';
import cartBarsService from './services/cartBars.service';
import rulesService from './services/rules.service';
import customDimensionColorRuleService from './services/customDimensionColorRule.service';
import notificationService from './services/notification.service';
import glassRulesService from './services/glassRules.service';
import ornamentGlassRuleService from './services/ornamentGlassRule.service';
import basementWindowRulesService from './services/basementWindowRules.service';
import duplexMullionRulesService from './services/duplexMullionRules.service';

import './app.scss';

const app = () => ({
    template: appTemplate,
    scope: {
        productid: '=',
        configurationid: '=',
        editproduct: '=',
        apiurl: '@',
        editsource: '@',
        moveablemullions: '<',
        issalesman: '<',
    },
    controller: 'AppCtrl',
    controllerAs: 'app',
});

export default angular.module('app', [
        angularSanitize,
        angularTranslate,
        uiSelect,
        ngCookies,
        config,
        clickableIconDirective,
        serieSelectorDirective,
        simpleSelectBoxDirective,
        handleSelectorDirective,
        configuratorHeaderDirective,
        componentSelectorDirective,
        modalAccessoriesDirective,
        colorSelectorDirective,
        glassSelectorDirective,
        barsSelectorDirective,
        packetSelectorDirective,
        toggleSimpleSelectBoxDirective,
        simpleBlindSelectorDirective,
        rollerBlindBoxSelectorDirective,
        rollerBlindFabricSelectorDirective,
        internalBlindTopRailSelectorDirective,
        internalBlindLouvreSelectorDirective,
        plisseRailSelectorDirective,
        plisseSheatingSelectorDirective,
        verticalBlindTopRailSelectorDirective,
        verticalBlindLouvreSelectorDirective,
        modalDirective,
        additionalMoneyFilter,
        dataService,
        apiService,
        imagesService,
        jsonService,
        jsonBuilderService,
        sashesService,
        dividersService,
        addMullionService,
        windowDimensionsService,
        internalSashesService,
        mullionsService,
        fixedSashesService,
        callbacksService,
        ncsService,
        cartBarsService,
        rulesService,
        handlesService,
        glazingSelectorDirective,
        customDimensionColorRuleService,
        notificationService,
        glassRulesService,
        ornamentGlassRuleService,
        basementWindowRulesService,
        duplexMullionRulesService,
    ])
    .config(appConfig)
    .controller('AppCtrl', AppCtrl)
    .factory('drawService', downgradeInjectable(DrawService))
    .directive('iccDraw', downgradeComponent({ component: IccDrawComponent }) /* as angular.IDirectiveFactory */ )
    .directive('app', app);